import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center justify-center border px-2.5 py-1 text-xs font-semibold transition-all duration-300 ease-out shadow-sm",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive:
          "border-transparent bg-gradient-to-br from-red-500 to-pink-500 text-destructive-foreground hover:from-red-600 hover:to-pink-600 shadow-sm",
        outline: "text-foreground",
        popular: 
          "border-transparent bg-gradient-to-r from-indigo-500 via-purple-500 to-blue-500 text-white hover:from-indigo-600 hover:via-purple-600 hover:to-blue-600 backdrop-blur-sm rounded-bl-xl rounded-tr-xl",
        current: 
          "border-transparent bg-gradient-to-r from-green-500 to-green-600 text-white hover:from-green-600 hover:to-green-700 backdrop-blur-sm rounded-bl-xl rounded-tr-xl",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }
